import "./about.css"
import Q from "../qualifications/q"
export default function About(){
    return(
        <div id="about" className="container about-container">
            <Q/>
        </div>
    )
}